/**
 * Pre-fills the protein calculator for a logged-in shopper, from the JSON that
 * snippets/calculadora-customer-data.liquid renders (nothing is rendered for a guest, so this is
 * a no-op for them). Ported from the Colombia theme.
 *
 * Deliberately left for the shopper every time:
 *  - the terms checkbox — consent is asked on each submission, never carried over;
 *  - the muscle/fat choice — it only applies to some BMIs, and is asked in context.
 * A field that already holds a value (browser autofill, back/forward restore) is not overwritten.
 *
 * Weight and height are stored metric (kg, metres). This store opens on lb / ft, so they are
 * converted to whichever unit system is active when the page loads.
 *
 * Must load after the section's inline scripts: their DOMContentLoaded listener sets up
 * intl-tel-input and the unit toggle, and has to run first.
 */
(function () {
  var ACTIVITY = { 'Muy activo': 0, 'Activo': 1, 'Poco activo': 2 };
  var KG_PER_LB = 0.453592;
  var CM_PER_INCH = 2.54;

  function read() {
    var el = document.getElementById('calculadora-customer-data');
    if (!el) {
      return null;
    }

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function blank(value) {
    return value == null || String(value).trim() === '';
  }

  function normalize(text) {
    return String(text).replace(/\s+/g, ' ').trim();
  }

  function isEmpty(id) {
    var el = document.getElementById(id);
    return !!el && el.value === '';
  }

  function fill(id, value) {
    var el = document.getElementById(id);
    if (!el || blank(value) || el.value !== '') {
      return;
    }

    if (el.tagName !== 'SELECT') {
      el.value = value;
      return;
    }

    // A select only takes one of its own options — a stored answer the merchant has since
    // removed from the list is dropped rather than leaving the select in an invalid state.
    for (var i = 0; i < el.options.length; i++) {
      if (el.options[i].value !== '' && normalize(el.options[i].value) === normalize(value)) {
        el.value = el.options[i].value;
        return;
      }
    }
  }

  function number(value) {
    var n = parseFloat(value);
    return isNaN(n) ? null : n;
  }

  function usSystem() {
    var el = document.getElementById('UsSystem');
    return !!el && el.classList.contains('active-system');
  }

  function fillWeight(value) {
    var kg = number(value);
    if (kg === null) {
      return;
    }

    fill('inputWeightK', String(Math.round(usSystem() ? kg / KG_PER_LB : kg)));
  }

  /** Stored in metres ("1.75"). Anything already cm-sized is kept as cm. */
  function fillHeight(value) {
    var n = number(value);
    if (n === null || !isEmpty('inputHeightCm')) {
      return;
    }

    var cm = n < 3 ? n * 100 : n;

    if (!usSystem()) {
      fill('inputHeightCm', String(Math.round(cm)));
      return;
    }

    var inches = Math.round(cm / CM_PER_INCH);
    fill('inputHeightCm', String(Math.floor(inches / 12)));
    if (isEmpty('inputHeightInch')) {
      fill('inputHeightInch', String(inches % 12));
    }
  }

  function fillPhone(phone) {
    var input = document.getElementById('phonemodal');
    if (!input || blank(phone) || input.value !== '') {
      return;
    }

    // The stored number is E.164 ("+13055551234"). setNumber() picks the country from it and,
    // with separateDialCode, leaves only the national part in the input — which is what the
    // submit handler expects next to `.iti__selected-dial-code`. Without the instance there's no
    // safe way to split the two, so the field is left for the shopper.
    var iti = window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance(input);
    if (iti) {
      iti.setNumber(phone);
    }
  }

  function fillActivity(activity) {
    if (!(activity in ACTIVITY) || typeof window.changeTab !== 'function') {
      return;
    }

    if (document.querySelector('.actividad-option-img.active')) {
      return;
    }

    window.changeTab(ACTIVITY[activity]);
  }

  function fillAnswer(data) {
    // The stored question is the one that was asked; if the merchant has changed it since, the
    // old answer belongs to a different question.
    var label = document.getElementById('preguntaadicionallabel');
    if (!blank(data.question) && label && normalize(label.textContent) !== normalize(data.question)) {
      return;
    }

    fill('preguntaAdicional', data.answer);
  }

  function apply() {
    var data = read();
    if (!data) {
      return;
    }

    fill('namemodal', data.firstName);
    fill('lastnamemodal', data.lastName);
    fill('emailmodal', data.email);
    fillPhone(data.phone);
    fillAnswer(data);

    var age = number(data.age);
    fill('inputAge', age === null ? null : String(Math.round(age)));
    fillWeight(data.weight);
    fillHeight(data.height);
    fill('selectGender', data.gender);
    fillActivity(data.activity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
